import { useTranslation } from 'react-i18next';
import { Paper, useMediaQuery } from '@mui/material';

import {
  TableContainerStyled,
  DetailsTableStyled,
  DetailsTableBodyStyled,
  DetailsTableRowStyled,
  DetailTitleCellStyled,
  DetailsBoxStyled,
  PlanDetailsContainerStyled,
} from './PlanDetailsTableStyled';
import { PlanContentDetailsDto } from 'enrollment/queries/useBenefitPlansQuery/types';
import { PlanDetailsCell } from './PlanDetailsCell';

interface PlanDetailsTableProps {
  contentDetails: PlanContentDetailsDto[];
}

export const PlanDetailsTable = ({ contentDetails }: PlanDetailsTableProps) => {
  const { t } = useTranslation('pages.benefits');

  const MAP_KEYS = ['in_network', 'out_of_network', 'preferred_network'];

  const isMobile = useMediaQuery('(max-width: 743px)');

  if (!contentDetails || contentDetails.length === 0) {
    return <></>;
  }

  return (
    <DetailsBoxStyled>
      <h2 className="headline-3">{t('planDetails')}</h2>
      <TableContainerStyled component={Paper}>
        <DetailsTableStyled className="details-table">
          <DetailsTableBodyStyled>
            {contentDetails.map((detail, index) => {
              return (
                <DetailsTableRowStyled key={index}>
                  <DetailTitleCellStyled align="left" className="col-md-4">
                    {detail.label}
                  </DetailTitleCellStyled>
                  <DetailTitleCellStyled align="left">
                    <PlanDetailsContainerStyled className="row">
                      {Object.entries(detail).map(([key, value], index) => {
                        if (MAP_KEYS.includes(key)) {
                          return (
                            <PlanDetailsCell
                              detailValue={value}
                              detailLabel={t(`${key}Label`)}
                              align={index > 0 ? 'left' : 'auto'}
                              isMobile={isMobile}
                              key={index}
                            />
                          );
                        } else {
                          return null;
                        }
                      })}
                    </PlanDetailsContainerStyled>
                  </DetailTitleCellStyled>
                </DetailsTableRowStyled>
              );
            })}
          </DetailsTableBodyStyled>
        </DetailsTableStyled>
      </TableContainerStyled>
    </DetailsBoxStyled>
  );
};
